import React from "react";
// import _ from "lodash";
import { Steps } from "antd";

const Step = Steps.Step;

class FormProgress extends React.Component {
  render() {
    const { formSteps, currentStep } = this.props;
    return (
      <div>
        <Steps direction="vertical" size="small" current={currentStep}>
          {formSteps.map(item => <Step key={item.step} title={item.label} />)}
        </Steps>
      </div>
    );
  }
}

export default FormProgress;



// WEBPACK FOOTER //
// ./src/Components/Services/FormProgress.js